import { render, staticRenderFns } from "./DeliverPrint.vue?vue&type=template&id=4b0a7612"
import script from "./DeliverPrint.vue?vue&type=script&lang=js"
export * from "./DeliverPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports